import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { z } from 'zod';

import { estimatedMonthlyTransactionValues } from '../../constants';
import { schema } from '../../schema';
import { estimatedMonthlyTransactionValueTextMap } from './StepForm.constants';

export const useFormData = () => {
    const currency = useWatch<z.infer<typeof schema>, 'accountUsage.estimatedMonthlyTransactionCurrency'>({
        name: 'accountUsage.estimatedMonthlyTransactionCurrency',
    });

    const estimatedMonthlyTransactionValueData = useMemo(
        () =>
            estimatedMonthlyTransactionValues.map((value) => ({
                text: estimatedMonthlyTransactionValueTextMap[value](currency),
                value,
            })),
        [currency]
    );

    return {
        estimatedMonthlyTransactionValueData,
    };
};
